export const easing = {
  outQuad: [0.25, 0.46, 0.45, 0.94],
}

export const duration = {
  fast: 0.2,
  normal: 0.3,
  stagger: 0.05,
}

export const spring = {
  default: { type: "spring", stiffness: 300, damping: 25 },
  snappy: { type: "spring", stiffness: 400, damping: 25 },
}

export const listItemAnimation = {
  initial: { opacity: 0, scale: 0.9 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: duration.normal, ease: easing.outQuad }
}

export const getListItemTransition = (index = 0) => ({
  ...listItemAnimation.transition,
  delay: index * duration.stagger
})
